var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center mt-8"},[_c('v-progress-circular',{staticClass:"mt-4",attrs:{"indeterminate":"","color":"smoke","width":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }